import lmsAPI from "./lmsAPI";

class locationImportsService {
  async get() {
    const res = await lmsAPI.get(`/locations/csv_import`);
    return res.data;
  }

  async create(CSVParams) {
    const res = await lmsAPI.post(`/locations/csv_import`, CSVParams);
    return res.data;
  }

  async delete() {
    const res = await lmsAPI.delete(`/locations/csv_import`);
    return res.data;
  }
}

export default new locationImportsService();
